import { Link } from 'react-router-dom';
import './Converterhomepage.css'; 
let Converterhomepage=()=>{
    let clicktoviewtools=()=>{
        let elm =document.querySelector(".tools");
        let ptag = document.querySelector(".subrightptag");
        elm.classList.toggle("active");
         if(elm.classList[2] === 'active'){
            elm.style.cssText= "transition: all 1s ease; right: 0; z-index: 100;"
            ptag.style.cssText="transition: all 1s ease; z-index: -100;"
         }else{
            elm.style.cssText= "transition: all 1s ease; right: -100%;" 
         }
    }
    let clicktoviewtoolsimage=()=>{
        let elm =document.querySelector(".imagetools");
        let ptag = document.querySelector(".subrightptagimageconvtr");
        elm.classList.toggle("active");
         if(elm.classList[3] === 'active'){
            elm.style.cssText= "transition: all 1s ease; right: 0; z-index: 100;"
            ptag.style.cssText="transition: all 1s ease; z-index: -100;"
       

         }else{
            elm.style.cssText= "transition: all 1s ease; right: -100%;" 
         }
    }
    let pdfdata = [
        {
            title: "PDF-TO-JPG",
            description: "Convert pdf to jpg formats",
            linkk: 'pdftojpegconvert'
        },
        {
            title: "PDF-TO-WORD",
            description: "Convert pdf to word format",
            linkk: 'pdftoword'
        },
         {
            title: "PDF-TO-POWERPOINT",
            description: "Convert pdf to Powerpoint",
            linkk: 'pfgtopowerpoint'
        },
         {
            title: "PDF-TO-EXCEL",
            description: "Convert pdf to Excel",
            linkk: 'pdftoexcel'
        }
        ,
         {
            title: "New Upcomming...",
            description: "More tools added soon",
            linkk: ''
        }
    ]

    let imagedata = [
        {
            title: "Image Resizer",
            description: "Convert your image in any resolution.",
            linkk: 'ImageResizer'
        },
         {
            title: "Image-To-PDF",
            description: "Convert JPG to PDF Easy and Fastly.",
            linkk: 'jpegtopdf'
        },
         {
            title: "New Upcomming...",
            description: "More tools added soon",
            linkk: ''
        }
    ] 
     
        
    return( 
        <div className='convrtmaincont'>
            <div className='firsthomepagecontent'>
                <p className='tophead'>Here You will Get all types of documents converter free 100%</p> 
                <div className='pdfconvertercont'>
                    <div  className='subleft sssmm'>PDF Converter<p onClick={clicktoviewtools}>Click to view Tools</p></div>
                    <div className='subright sssmm'>
                        <p className='subrightptag'></p>        
                        <div className='tools sssmm'> 
                            <p className='alltoolheading'>All pdf converter tools</p>
                            <div className='subpdftooltoolcont'>
                                {
                                    pdfdata.map(
                                        aa=>(
                                            <Link to={aa.linkk} className='firsttool'>
                                                <p style={{margin:"0"}}>{aa.title}</p>
                                                <p style={{margin:"0"}} className='description'>{aa.description}</p>
                                             
                                            </Link>
                                        )
                                    )
                                }
                               
                                        
                            </div>
                        </div>
                    </div>
                </div> 
                 <div className='pdfconvertercont'>
                    <div  className='subleft sssmm'>Image Converter <p onClick={clicktoviewtoolsimage}>Click to view Tools</p></div>
                    <div className='subright sssmm'>
                        <p className='subrightptagimageconvtr'></p>       
                        <div className='tools imagetools sssmm'> 
                            <p className='alltoolheading'>All Image converter Tools</p>
                            <div className='subpdftooltoolcont'>
                                 {
                                    imagedata.map(
                                        aa=>(
                                            <Link to={aa.linkk} className='firsttool'>
                                                <p>{aa.title}</p>
                                                <p>{aa.description}</p>
                                             
                                            </Link>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    );
}
export default Converterhomepage;